export const COLOR_CONSTANTS = {
  "on-primary/variant": "#2B44C1",
  "primary/variant": "#EBEEFE",
  "primary/default": "#3655F2",
  "on-surface/secondary": "#666666",
  "tertiary-yellow/default": "#F19E2B",
  "tertary-green/default": "#DAECDE",
  "tertiary-green/variant": "#469E59",
  "tertiary-green/variant2": "#387E47",

  "tertiary-red/default": "#DB382A",
  "tertiary-red/variant2": "#FBEBEA",
};
